<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.documentTo }}</v-subheader>
        <span class="queryValue">{{ objData.documentTo }}</span>
        <!-- <v-text-field :label="documentDetLabel.documentTo" v-model="objData.documentTo" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.toPrint }}</v-subheader>
        <span class="queryValue">{{ objData.toPrint }}</span>
        <!-- <v-text-field :label="documentDetLabel.toPrint" v-model="objData.toPrint" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md12 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.addressedTo }}</v-subheader>
        <span class="queryValue">{{ objData.addressedTo }}</span>
        <!-- <v-text-field :label="documentDetLabel.addressedTo" v-model="objData.addressedTo" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md12 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.mailingAddress }}</v-subheader>
        <span class="queryValue">{{ objData.mailingAddress }}</span>
        <!-- <v-text-field :label="documentDetLabel.mailingAddress" v-model="objData.mailingAddress" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md12 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.remarks }}</v-subheader>
        <span class="queryValue">{{ objData.remarks }}</span>
        <!-- <v-text-field :label="documentDetLabel.remarks" v-model="objData.remarks" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md12 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.statementRef }}</v-subheader>
        <span class="queryValue">{{ objData.statementRef }}</span>
        <!-- <v-text-field :label="documentDetLabel.statementRef" v-model="objData.statementRef" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ objData.debitNoteLbl }}</v-subheader>
        <span class="queryValue">{{ objData.debitNote }}</span>
        <!-- <v-text-field :label="objData.debitNoteLbl" v-model="objData.debitNote" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.bankList }}</v-subheader>
        <span class="queryValue">{{ objData.bankList }}</span>
        <!-- <v-text-field :label="documentDetLabel.bankList" v-model="objData.bankList" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.bankPayinList }}</v-subheader>
        <span class="queryValue">{{ objData.bankPayinList }}</span>
        <!-- <v-text-field :label="documentDetLabel.bankPayinList" v-model="objData.bankPayinList" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.branchDocumentList }}</v-subheader>
        <span class="queryValue">{{ objData.branchDocumentList }}</span>
        <!-- <v-text-field :label="documentDetLabel.branchDocumentList" v-model="objData.branchDocumentList" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.taxInvoiceNo }}</v-subheader>
        <span class="queryValue">{{ objData.taxInvoiceNo }}</span>
        <!-- <v-text-field :label="documentDetLabel.taxInvoiceNo" v-model="objData.taxInvoiceNo" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.printTaxInvoice }}</v-subheader>
        <span class="queryValue">{{ objData.printTaxInvoice }}</span>
        <!-- <v-text-field :label="documentDetLabel.printTaxInvoice" v-model="objData.printTaxInvoice" readonly hide-details></v-text-field> -->
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ documentDetLabel.theirTaxInvoiceNo }}</v-subheader>
        <span class="queryValue">{{ objData.theirTaxInvoiceNo }}</span>
        <!-- <v-text-field :label="documentDetLabel.theirTaxInvoiceNo" v-model="objData.theirTaxInvoiceNo" readonly hide-details></v-text-field> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      documentDetLabel: {
        documentTo: 'Document To',
        toPrint: 'To Print',
        addressedTo: 'Addressed To',
        mailingAddress: 'Mailing Address',
        remarks: 'Remarks',
        statementRef: 'Statement Reference',
        debitNoteLbl: 'This Debit Note',
        bankList: 'Bank List',
        bankPayinList: 'Bank Pay-in List',
        branchDocumentList: 'Branch Document List',
        taxInvoiceNo: 'Tax Invoice No.',
        printTaxInvoice: 'Print Tax Invoice',
        theirTaxInvoiceNo: 'Their Tax Invoice No.'
      }
    }
  },
  mounted() {},
  methods: {},
  computed: {},
  props: {
    objData: {
      type: Object,
      default: null
    }
  }
}
</script>
